import Swal from 'sweetalert2'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { baixarAsosLote } from '../../core/_request'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { getAtendimentoById } from '../../../../atendimento/core/_requests'
import { Button, TableSelectionBar, useToast } from '../../../../../../components'
import { IconPaths, showAlertLoading, showError } from '../../../../../../../_metronic/helpers'

const asos = (n: number) => `${n} ${n === 1 ? 'ASO' : 'ASOs'}`

export const DownloadAsoListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { response } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  const handleDownload = async () => {
    showAlertLoading()

    // A situação de cada ASO vem da linha da página atual; selecionados de outra página
    // (a seleção sobrevive à troca de página) são buscados.
    const naPagina = (response?.data ?? []).filter((a) => selected.includes(a.id))
    const idsFora = selected.filter((id) => !naPagina.some((a) => a.id === id))
    let atendimentos: AtendimentoList[] = naPagina
    try {
      const fora = await Promise.all(idsFora.map((id) => getAtendimentoById(id)))
      atendimentos = [...naPagina, ...(fora.filter(Boolean) as AtendimentoList[])]
    } catch (error) {
      showError(error)
      return
    }

    const { baixados, erros, primeiroErro } = await baixarAsosLote(atendimentos)
    Swal.close()

    if (baixados === 0) {
      showError(primeiroErro)
    } else if (erros > 0) {
      showToast({
        variant: 'warning',
        title: `${asos(baixados)} baixado(s), ${asos(erros)} com erro.`,
        description: 'Tente baixar de novo os que falharam.',
      })
    } else {
      showToast({ variant: 'success', title: `${asos(baixados)} baixado(s).` })
    }
    clearSelected()
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <Button className='btn-primary' icon={IconPaths.Download} onClick={handleDownload}>
        {count === 1 ? 'Baixar ASO' : `Baixar ASOs`}
      </Button>
    </TableSelectionBar>
  )
}
